import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/EditProperty.css";

function EditProperty() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    id: "",
    location: "",
    price: "",
    postedBy: "",
    status: "",
    listingType: "",
    images: [],
  });

  // 🔥 Fetch data
  useEffect(() => {

    fetch("https://urbanbrick.in.net/realestate_new/get-properties.php")
      .then(res => res.json())
      .then(data => {

        const selected = data.find(item => item.id.toString() === id);

        if (selected) {
          setForm(selected);
        }

      })
      .catch(err => console.log(err));

  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔥 Submit update
  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("https://urbanbrick.in.net/update-property.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    })
      .then(res => res.json())
      .then(data => {

        if (data.status === "success") {
          alert("Property Updated Successfully");
          navigate("/admin/dashboard");
        } else {
          alert("Update failed");
        }

      })
      .catch(err => {
        console.log(err);
        alert("Server error");
      });

  };

  return (
    <div className="edit-container">
      <div className="edit-card">
        <h2>Edit Property</h2>

        <form onSubmit={handleSubmit} className="edit-form">

         
          <div className="form-group">
            <label>Address</label>
            <input
              name="location"
              value={form.location}
              onChange={(e) => {
                const words = e.target.value.trim().split(/\s+/);
                if (words.length <= 50) {
                  setForm({ ...form, location: e.target.value });
                }
              }}
              required
            />
          </div>

          {/* PRICE */}
          <div className="form-group">
            <label>Price</label>
            <input
              name="price"
              value={form.price}
              onChange={handleChange}
              required
            />
          </div>

          {/* POSTED BY */}
          <div className="form-group">
            <label>Posted By</label>
            <input
              name="postedBy"
              value={form.postedBy}
              onChange={handleChange}
              required
            />
          </div>

          {/* STATUS */}
          <div className="form-group">
            <label>Status</label>
            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Active">Active</option>
              <option value="Closed">Closed</option>
            </select>
          </div>

          {/* LISTING TYPE */}
          <div className="form-group">
            <label>Listing Type</label>
            <select
              name="listingType"
              value={form.listingType}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Buy">Buy</option>
              <option value="Sell">Sell</option>
              <option value="Rent">Rent</option>
            </select>
          </div>

          <button type="submit" className="update-btn">
            Update Property
          </button>

        </form>
      </div>
    </div>
  );
}

export default EditProperty;